import {ref, Ref} from 'vue';
import {DichVu} from '@/models/dichVu';
import repository from '@/services/BenhNhanRepository';

// Một nguồn dữ liệu được duyệt cho toàn bộ màn hình trong khoa đang chọn.
export function useDichVuKhoa(khoa: Ref<number>) {
  const listDichVu = ref([] as DichVu[]);
  const dangTaiDichVuKhoa = ref(false);
  let phien = 0;
  const taiDichVuKhoa = async () => {
    const current = ++phien;
    const id = khoa.value;
    listDichVu.value = [];
    if (!id) { dangTaiDichVuKhoa.value = false; return; }
    dangTaiDichVuKhoa.value = true;
    try {
      const response = await repository.getDichVuKhoa(id);
      if (current === phien && khoa.value === id) listDichVu.value = response.data;
    } finally {
      if (current === phien) dangTaiDichVuKhoa.value = false;
    }
  };
  return {listDichVu, dangTaiDichVuKhoa, taiDichVuKhoa};
}
